import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'transparent',
    color: 'black',
  },
  title: {
    flexGrow: 1,
    whiteSpace: 'nowrap',
    width: '80%',
  },
  icon: {
    color: 'white',
    backgroundColor: '#3E984C',
    '&:hover': {
      backgroundColor: '#2B6A35',
    },
  },
}))
